import React from 'react';
import { createRoot } from 'react-dom/client';
import Phaser from 'phaser';
import { gameConfig } from './game/config';
import { GameOverlay } from './components/GameOverlay';
import './index.css';

// Mount React overlay on top of the game
const overlayRoot = document.getElementById('overlay-root');
if (overlayRoot) {
  createRoot(overlayRoot).render(
    <React.StrictMode>
      <GameOverlay />
    </React.StrictMode>
  );
}

// Start Phaser game
const game = new Phaser.Game(gameConfig);

export { game };
